import { AlertColor } from "@mui/material";
import classNames from "classnames";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { ampli } from "../../../../ampli";
import { IUserProperties } from "../../../../ampli/models";
import { ampliIncrementEvent } from "../../../../ampli/userIdentify";
import { LINK_COPIED } from "../../../../pages/contract/constants";
import { deleteContractById } from "../../../../setup/api/services/contract";
import { ROUTES } from "../../../../setup/constants";
import { AuthConfig } from "../../../../setup/context/config/authConfig";
import { DialogModal } from "../../../common/dialog";
import OutlinedButton from "../../../common/OutlinedButton";
// components
import PrimaryButton from "../../../common/PrimaryButton";
import CustomizedSnackbars from "../../../customizedSnackbars";
import { IContractActionComponentProps } from "../models";
import { ConfirmPinCodeForm } from "../pinActionModal/confirmPinCodeForm";
// styles
import styles from "./activeContract.module.scss";
import { DeleteContractForm } from "./forms/deleteContractForm";

export const ActiveContractActions = (props: IContractActionComponentProps) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { refreshContractDetails } = props;
  const { t } = useTranslation();
  const userId = AuthConfig.getUserInfo().id;
  const [verifiedPinCode, setVerifiedPinCode] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [snackBarOpen, setSnackBarOpen] = useState<boolean>(false);
  const [snackBarColor, setSnackBarColor] = useState<AlertColor>();
  const [snackBarTitle, setSnackBarTitle] = useState<string>("");
  const toggleModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
    setVerifiedPinCode(false);
    setSnackBarOpen(false);
    setSnackBarColor(undefined);
    setSnackBarTitle("");
  };

  const setSnackBarStates = (title: string, color: AlertColor) => {
    setSnackBarOpen(true);
    setSnackBarColor(color);
    setSnackBarTitle(title);
  };

  const onCopy = () => {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    setSnackBarStates(LINK_COPIED, "success");
    setTimeout(() => {
      setSnackBarOpen(false);
    }, 3000);
    ampli.sharedContract({
      shareContractPageSource: "contractDetailsPage", // enum,
      shareContractMethod: "Others", // enum
      contractId: props.contract.shortId,
    });
  };
  const sendAmpliEventDeletedContract = () => {
    ampli.deletedContract({
      userRole: "seller", // enum
      contractDeletionDate: new Date().toISOString(), // string
      contractId: props.contract.shortId,
    });
  };
  const sendAmpliUserPropertiesForDeletedContract = () => {
    ampliIncrementEvent(
      userId,
      IUserProperties.TOTAL_NUMBER_OF_CONTRACT_DELETED
    );
  };
  const onDelete = () => {
    if (id)
      deleteContractById(id)
        .then(() => {
          sendAmpliUserPropertiesForDeletedContract();
          sendAmpliEventDeletedContract();

          setSnackBarStates(`${t("lbl_deleted_successfully")}`, "success");
          navigate(ROUTES.CONTRACTS_LIST);
          closeModal();
        })
        .catch(() => {
          setSnackBarStates(`${t("lbl_cannot_be_deleted")}`, "error");
          refreshContractDetails();
          closeModal();
        });
  };
  const onConfirm = () => {
    setVerifiedPinCode(true);
    return;
  };
  const renderModal = () => {
    return (
      <DialogModal
        title={
          verifiedPinCode
            ? t("lbl_are_you_sure_want_to_delete_this_contract")
            : t("lbl_authentication_through_pincode_title")
        }
        open={modalOpen}
        handleClose={async () => {
          closeModal();
        }}
        className={styles.modalContainer}>
        {verifiedPinCode ? (
          <DeleteContractForm onDelete={onDelete} onCancel={closeModal} />
        ) : (
          <ConfirmPinCodeForm
            description={t("lbl_delete_sub_title")}
            onConfirm={onConfirm}
          />
        )}
      </DialogModal>
    );
  };
  const renderSnackBar = () => {
    return snackBarOpen ? (
      <CustomizedSnackbars
        open={snackBarOpen}
        title={snackBarTitle}
        type={snackBarColor}
      />
    ) : null;
  };
  return (
    <div className={styles.container}>
      <div style={{ width: "100%" }} className={"row"}>
        <div className={"flex8"}>
          <PrimaryButton id={`contract_details_copy`} onClick={onCopy}>
            {" "}
            <p className={classNames("subtitle2", "white")}>
              {t("lbl_copy_url")}
            </p>
          </PrimaryButton>
        </div>
        <div className={"flexDivider"} />
        <div className={"flex2"}>
          {renderModal()}
          {renderSnackBar()}
          <OutlinedButton
            id={`contract_details_delete_contract`}
            onClick={toggleModal}>
            <p className={classNames("subtitle2", "primary")}>حذف</p>
          </OutlinedButton>
        </div>
      </div>
    </div>
  );
};
